<template>
  <validation-provider
    ref="provider"
    v-slot="{ errors }"
    :rules="rules"
  >
    <input-date
      v-model="model"
      :label="label"
      :input-class="[inputClass, {'border-red-500': errors.length}]"
      :disabled="disabled"
      v-bind="$attrs"
    />
    <p
      v-if="errors.length"
      class="text-xs text-red-500"
      v-text="errors[0]"
    />
  </validation-provider>
</template>

<script>
import InputDate from '@/components/form/date'

export default {
  components: {
    InputDate
  },
  props: {
    value: {
      type: [Date, String],
      default: ''
    },
    label: {
      type: String,
      default: null
    },
    inputClass: {
      type: [Object, Array, String],
      default: ''
    },
    rules: {
      type: String,
      default: null
    },
    disabled: Boolean
  },
  data: () => ({
    model: ''
  }),
  watch: {
    model (value) {
      this.$emit('input', value)
    }
  },
  beforeMount () {
    this.model = this.value
  },
  methods: {
    validate () {
      return this.$refs.provider.validate()
    },
    setErrors (errors) {
      this.$refs.provider.setErrors(errors)
    }
  }
}
</script>
